import { getPath, PathUnit } from '@/app/consts/path.const';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-forbidden',
  imports: [RouterLink],
  templateUrl: './forbidden.component.html',
  styleUrl: './forbidden.component.scss'
})
export class ForbiddenComponent {
  dashboardPath = getPath(PathUnit.Dashboard)
  // requestAccessPath = getPath(PathUnit.RequestAccess)

}
